import { LitElement, html, css } from 'lit';
import { restMethods } from '../mixins/rest_methods';
import { createSuccessBar } from '../packs/notification_bar';
import '../packs/outline_button';
import '../packs/modal';
import './propose-notification-modal';
import './propose-login-modal';

class AvailabilityConditionNotificationCreateButton extends LitElement {
  static properties = {
    conditions: { type: Object },
    isLogin: { type: Boolean, reflect: true},
    isModalOpen: { type: Boolean, reflect: true },
    isPaidUser: { type: Boolean, reflect: true },
    isAdmin: { type: Boolean, reflect: true},
hasCustomerId: { type: Boolean, reflect: true},
  }
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    console.log('constructor');
    this.isModalOpen = false;
    this.isLogin = false;
    this.disabled = false;
    this.isPaidUser = false;
    this.isAdmin = false;
  } 
  updated(changedProperties) {
    
  }
  static styles = css`
  .description {
    color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    margin-bottom: 23px;
    .orange-mark {
      color: #D76315;
      font-weight: 700;
    }
  }
  .notice {
    display: flex;
    color: #A8ABA6;
    gap: 4px;
    font-family: "Noto Sans JP";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    margin-bottom: 32px;
  }
  .upgrade-button {
    margin-bottom: 32px;
  }
  .supporter-link {
    margin-bottom: 24px;
  }
  .cancel-button {
    display: flex;
    justify-content: end;
  }
  `
  async registNotification() {
    console.log(this.isLogin)
    if(!(this.isPaidUser || this.isAdmin)) {
      this.isModalOpen = true;
      return;
    }


    console.log('registNotification');
    const cityIds = this.conditions.cities.map(city => city.id);
    const sportsTypeIds = this.conditions.sports_types.map(sportsType => sportsType.id);
    const facilityTypeIds = this.conditions.facility_types.map(facilityType => facilityType.id);
    const priceRange = this.conditions.price_ranges.map(priceRange => ({id: priceRange.id, price_use_unit_id: priceRange.price_use_unit_id}));
    const tagIds = this.conditions.tags.map(tag => tag.id);
    const startDate = this.conditions.availabilities?.[0]?.start_date;
    const endDate = this.conditions.availabilities?.[0]?.end_date;
    const params = {
      availability_notification: {
        condition: {
          city_ids: cityIds,
          sports_type_ids: sportsTypeIds,
          facility_type_ids: facilityTypeIds,
          price_ranges: priceRange,
          tag_ids: tagIds
        },
        start_date: startDate,
        end_date: endDate
      }
    }
    const response = await restMethods.methods.postMethod("/availability_notifications", params)
    if (response.status == 201) {
      createSuccessBar(`
        <div>空き状況の通知を登録しました</div>
        <div>通知内容の確認は<a href="/mypage#availability_notification_edit">マイページ</a>から行えます</div>
        
      `);
    }
    this.disabled = true;
  }
  closeModal() {
    this.isModalOpen = false;
  }
  renderModal() {
    if(this.isLogin && !(this.isPaidUser || this.isAdmin)) {
      return html`
        <propose-notification-modal
          .isModalOpen="${this.isModalOpen}"
          @close="${this.closeModal}"
          .hasCustomerId="${this.hasCustomerId}"
        ></propose-notification-modal>
      `;
    }
    else if(!this.isLogin) {
      return html`
        <propose-login-modal
          .isModalOpen="${this.isModalOpen}"
          @close="${this.closeModal}"
        ></propose-login-modal>
      `;
    }
  } 
  render() {
    return html`
      <outline-button
        @click="${this.registNotification}"
        .disabled="${this.disabled}"
      >
        ${(this.disabled) ? '空き状況の通知は登録済みです' : 'この検索条件で空き状況の通知を登録'}
      </outline-button>
      ${this.renderModal()}
    `;
  }
}
customElements.define('availability-condition-notification-create-button', AvailabilityConditionNotificationCreateButton);